
export const CopyIcon = () => {

    return (
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.5 11V3H11.5V1H1.5V11H3.5Z" fill="white" fill-opacity="0.98" />
        <path d="M5.5 5H15.5V15H5.5V5Z" fill="white" fill-opacity="0.98" />
      </svg>
  
    );
  }